import { aaId } from './aaId';

// We access memberId directly rather than calling getAaId because the
// getAaId function reads the cookie and this can degrade performance.
// eslint-disable-next-line @eslint-react/hooks-extra/no-useless-custom-hooks
export const useAaId = () => {
  return aaId;
};
